import { Injectable } from '@angular/core';
import {
  AuthActions,
  AuthRedirectService,
  AuthService,
  AuthStorageService,
  GlobalMessageService,
  GlobalMessageType,
  OCC_USER_ID_CURRENT,
  RoutingService,
  StateWithClientAuth,
  UserIdService,
} from 'haba-core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { HabaOAuthLibWrapperService } from './oauth-lib-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class HabaAuthService extends AuthService {
  constructor(
    protected store: Store<StateWithClientAuth>,
    protected userIdService: UserIdService,
    protected oAuthLibWrapperService: HabaOAuthLibWrapperService,
    protected authStorageService: AuthStorageService,
    protected authRedirectService: AuthRedirectService,
    protected routingService: RoutingService,
    private router: Router,
    private globalMessageService: GlobalMessageService
  ) {
    super(
      store,
      userIdService,
      oAuthLibWrapperService,
      authStorageService,
      authRedirectService,
      routingService
    );
  }

  /**
   * Loads a new user token with Resource Owner Password Flow.
   * @param userId
   * @param password
   */
  async loginWithCredentials(userId: string, password: string): Promise<void> {
    try {
      await this.oAuthLibWrapperService.authorizeWithPasswordFlow(userId, password);
      // OCC specific user id handling. Customize when implementing different backend
      this.userIdService.setUserId(OCC_USER_ID_CURRENT);

      this.store.dispatch(new AuthActions.Login());

      if (!this.router.url.includes('/checkout')) {
        this.authRedirectService.redirect();
      }
    } catch (error) {
      if (error.cause?.status !== 403) {
        this.globalMessageService.add(
          { key: `habaHttpHandlers.registration.genericError` },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }

      return error.cause?.status;
    }
  }
}
